export const handleSelectOrDeselect = (type, setType, value) => {
  if (type === value) {
    setType(null) // Deselect the option if it is already selected
  } else {
    setType(value) // Select the option if it is not selected
  }
}
